module.exports = __webpack_public_path__ + "img/contact-banner-large.png";